import { render, staticRenderFns } from "./OrderPaymentStatus.vue?vue&type=template&id=792fb058&scoped=true&"
import script from "./OrderPaymentStatus.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentStatus.vue?vue&type=style&index=0&id=792fb058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792fb058",
  null
  
)

export default component.exports